import client from './../../utils/http-client'
import {injectable} from "inversify";

export class PostsService {
    constructor() {
        this.client = client;
    }

    async getPostDetailById(id) {
        const postReponse = await client.get(`posts/${id}`);
        if(postReponse.status !== 200) {
            return false;
        }
        return postReponse.data;
    }

    async getPostDetailBySlug(slug) {
        const postReponse = await client.get(`posts?slug=${slug}`);
        if(postReponse.status !== 200) {
            return false;
        }
        return postReponse.data[0];
    }

    async getLastPostsByCategory(categoria) {
        const postsReponse = await client.get(`posts`, {
            params: {
                categories: categoria,
                orderby: 'date',
                order: 'desc'
            }
        });
        if(postsReponse.status !== 200) {
            return false;
        }
        return postsReponse.data;
    }

    async getLastPosts() {
        const postsReponse = await client.get(`posts`, {
            params: {
                orderby: 'date',
                order: 'desc'
            }
        });
        if(postsReponse.status !== 200) {
            return false;
        }
        return postsReponse.data;
    }

    async getPostComments(postId) {
        const commentsReponse = await client.get(`comments?post=${postId}`);
        if(commentsReponse.status !== 200) {
            return false;
        }
        return commentsReponse.data;
    }

    async getPostAuthor(userId) {
        const authorResponse = await client.get(`users/${userId}`);
        if(authorResponse.status !== 200) {
            return false;
        }
        return authorResponse.data;
    }

    async getPostTags(tags) {
        const postTagsResponse = await client.get(`tags?include=${tags.join(',')}`);
        if(postTagsResponse.status !== 200) {
            return false;
        }
        return postTagsResponse.data;
    }

    async getPostMedia(mediaId) {
        const postTagsResponse = await client.get(`media/${mediaId}`);
        if(postTagsResponse.status !== 200) {
            return false;
        }
        return postTagsResponse.data;
    }
}
injectable()(PostsService);
